import "core-js/modules/es.object.to-string";
import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ErrorPage from '@/pages/index/views/Error/errorPage/index.vue';
Vue.use(Router);
export default new Router({
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }, {
    path: '/live',
    name: 'live',
    // route level code-splitting
    // which is lazy-loaded when the route is visited.
    component: function component() {
      return import(
      /* webpackChunkName: "video" */
      './views/Video.vue');
    }
  }, {
    path: '/error',
    name: 'error2',
    meta: {
      title: '页面发生错误',
      loading: 'auto'
    },
    component: ErrorPage
  }, {
    path: '*',
    name: '404',
    meta: {
      title: '404',
      loading: 'auto'
    },
    component: ErrorPage
  }]
});